import axios from "axios";
import { getApiUrl } from "../baseUrl";

export const authenticateUserHandler = (params) => {
  return axios.get(getApiUrl() + `/api_explorer/apiAuthentication${params ? `${params}&` : "?"}lead_source=free%20trial`);
};

export const verifyUserHandler = (params) => {
  return axios.post(getApiUrl() + "/api_explorer/verifyOtp", params);
};

export const websiteTrackingApi = (params) => {
  return axios.post(getApiUrl() + "/websiteUserActivityTracking", params);
};
